module.exports = __webpack_public_path__ + "static/build-your-package-580fe6b48a7d7d088efce63cb3e65aa1.svg";